<template>
  <div class="w80-crpwd my-20">
    <div class="row text-center">
      <div class="col-lg-6 col-md-4 col-sm-12 col-xs-12 d-none d-sm-block">
        <img class="LiamMaxBuscarCuenta" src="../../../../src/assets/2026/recupe_password.jpg" alt="IsackMaxMobil">
      </div>
      <div class="col-lg-6 col-md-8 col-sm-12 col-xs-12">
        <div class="contenedor-form-buscarCuenta">
          <!-- <img class="headregisterBC d-sm-none" src="../../../assets/registerHead.png" alt="Mobile Logo"> -->
          <h1 class="font-white font-bold buscarCuenta-titulo">Buscar cuenta de correo</h1>
          <p class="font-white font-regular buscarCuenta-texto mt-5 mb-5 ">Acelera hacia la emoción e inicia sesión en
            tu cuenta
            para disfrutar de la experiencia de predicción más emocionante de la Gran Carrera.</p>
          <!-- <p class="font-white font-bold buscarCuenta-segundo-titulo mb-5">Iniciar Sesión</p> -->
          <form action="" class="w100" @submit.prevent="submitFormBuscarCuenta">
            <div class="form-group mb-5 BC">
              <input type="email" class="form-control input24" id="email" v-model="form.email" placeholder="Correo">
            </div>
            <!-- <div class="form-group mb-5">
              <input type="text" class="form-control input24" id="password" placeholder="Confirmar contraseña*">
                </div> -->
            <div class="d-flex justify-center mt-10">
              <button class="btn btn-primary btn-lg btn-launch-crpwd registrarse">¡Inicia sesión
                ahora mismo!</button>
            </div>
          </form>
          <!-- <a class="font-white mt-5" href="">Olvidaste tu contraseña</a> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script src="./buscarCuenta.js" />
<style src="./buscarCuenta.scss" lang="scss" />
<style src="../../../App.scss" lang="scss" />
<script>
import axios from 'axios';
import swal from 'sweetalert2';

export default {
  name: 'CompruebaCuenta',
  metaInfo: {
    title: 'Comprueba tu cuenta| Mobil Predictor',
    meta: [
      { name: 'title', content: 'Comprueba tu cuenta| Mobil Predictor' },
      { name: 'description', content: 'Crea tu cuenta y participa en pronósticos de alto nivel. Demuestra tu pasión por la máxima categoría del deporte motor. ¡Da clic aquí!' }
    ]
  },
  data() {
    return {
      form: {
        email: ''
      },
    };
  },
  methods: {
    async submitFormBuscarCuenta() {
      try {
        axios.defaults.headers.common['Content-Type'] = 'application/json';
        const response = await axios.post(
          // 'https://www.mobilpredictor.com.mx/datos/api/buscarCuentaSF',
          // 'http://127.0.0.1:8000/api/buscarCuentaSF',
          'https://api.mobilpredictor2025.vmtec.com.mx/api/buscarCuentaSF',
          this.form
        );
        // console.log(response.data.result)

          if (response.data.result == 'userExists'){
            swal.fire({
              icon: 'info',
              title: '¡Ups!',
              text: 'El correo que ingresaste ya está registrado en nuestra base de datos. Seras redireccionado al inicio de sesión.',
              background: "rgba(0, 20, 79, 0.8)",
              confirmButtonColor: "#ff0000",
              color: "#fff",
            });
            setTimeout(() => {
              this.$router.push('/iniciar-sesion');
            }, 3000);
          }else{
            this.$router.push('/crear-contrasena/' + response.data.result);
          }

          if (response.data.result == "NoUserSF") {
          swal.fire({
              icon: 'info',
              title: '¡Ups!',
              html: "Parece que aún no formas parte del paddock.<br>👀 Crea tu cuenta en Mobil Predictor y demuestra todo lo que sabes de la máxima categoría del automovilismo.",
              background: "rgba(0, 20, 79, 0.8)",
              confirmButtonColor: "#ff0000",
              color: "#fff",
            });
        }
      } catch (error) {
        // console.error(error.response.data.result);
        if (error.response.data.result == "NoUserSF") {
          swal.fire({
              icon: 'info',
              title: '¡Ups!',
              html: "Parece que aún no formas parte del paddock.<br>👀 Crea tu cuenta en Mobil Predictor y demuestra todo lo que sabes de la máxima categoría del automovilismo.",
              background: "rgba(0, 20, 79, 0.8)",
              confirmButtonColor: "#ff0000",
              color: "#fff",
            });
        }
      }
    },
  },
}
</script>
